"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userCentreSchemaDef = exports.centreSchemaDef = exports.centreBaseSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
const general_1 = require("../general");
const ComponentSeries_1 = require("./ComponentSeries");
exports.centreBaseSchemaDef = {
    ...general_1.daoObjSchemaDef,
    id: joi_1.default.string().required(),
    name: joi_1.default.string().required(),
};
exports.centreSchemaDef = {
    ...exports.centreBaseSchemaDef,
    zone: ComponentSeries_1.examDateSchemaDef['zone'],
    zoneId: ComponentSeries_1.examDateSchemaDef['zoneId'],
};
exports.userCentreSchemaDef = {
    ...exports.centreSchemaDef,
    role: joi_1.default.string(),
};
